export const RESET = "reset";
export const SET_NEW_SERVICE_ORIGIN = "setNewServiceOrigin";
export const ADD_NEW_SERVICE_DESTINATION = "addNewServiceDestination";
export const DELETE_NEW_SERVICE_DESTINATION = "deleteNewServiceDestination";
export const SET_NEW_SERVICE_DRIVER = "setNewServiceDriver";
export const SET_NEW_SERVICE_USER = "setNewServiceUser";
export const SET_SELECTED_DESTINATION_INDEX = "setSelectedDestinationIndex";
export const SET_NEW_SERVICE_ESTIMATION = "setNewServiceEstimation";
export const SET_NEW_SERVICE_DATE = "setNewServiceDate";
